module.exports = __webpack_public_path__ + "mf.jpg?321a1c51ac7ec27dfae7dc230f3ddeb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mf.jpg
// module id = 87
// module chunks = 0